import React from 'react';

const PetAvatar = ({ petType, size = 'md', animated = false }) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-lg',
    md: 'w-12 h-12 text-2xl',
    lg: 'w-16 h-16 text-3xl',
    xl: 'w-24 h-24 text-5xl'
  };

  const petEmojis = {
    'Dog': '🐕',
    'Cat': '🐱',
    'Bird': '🦜',
    'Fish': '🐠',
    'Rabbit': '🐰',
    'Hamster': '🐹',
    'Guinea Pig': '🐹',
    'Reptile': '🦎',
    'Horse': '🐴',
    'Pig': '🐷'
  };

  const gradientColors = {
    'Dog': 'from-amber-400 to-orange-500',
    'Cat': 'from-purple-400 to-pink-500',
    'Bird': 'from-blue-400 to-cyan-500',
    'Fish': 'from-cyan-400 to-blue-500',
    'Rabbit': 'from-pink-400 to-rose-500',
    'Hamster': 'from-yellow-400 to-amber-500',
    'Guinea Pig': 'from-green-400 to-emerald-500',
    'Reptile': 'from-emerald-400 to-green-600',
    'Horse': 'from-slate-400 to-gray-600',
    'Pig': 'from-rose-400 to-pink-500'
  };

  const emoji = petEmojis[petType] || '🐾';
  const gradient = gradientColors[petType] || 'from-gray-400 to-gray-500';

  return (
    <div 
      className={`
        ${sizeClasses[size]} 
        bg-gradient-to-br ${gradient} 
        rounded-full 
        flex items-center justify-center 
        shadow-lg
        ${animated ? 'animate-bounce hover:animate-pulse' : 'hover:scale-110'}
        transition-all duration-300
        cursor-pointer
      `}
    >
      <span className="filter drop-shadow-sm">
        {emoji}
      </span>
    </div>
  );
};

export default PetAvatar;